import React from 'react';
import { connect } from 'react-redux';
import { Link } from '@beef/ui-kit';
import { getTariffButtonText, getTariffUrl } from "../../../../../../../../store/blocks/tariffs/tariffSelectors";
import { buildOrderQueryParams } from "../../../../../store/selectors/orderTariffCommon";
export var _TariffButton = function _TariffButton(_ref) {
  var children = _ref.children,
    href = _ref.href;
  return /*#__PURE__*/React.createElement(Link, {
    buttonSize: "m",
    buttonVariant: "main",
    href: href,
    size: "size5-m",
    target: "_self",
    variant: "button",
    "data-t-id": "components-TariffButton"
  }, children);
};

// @ts-expect-error TODO: типизировать store
var mapStateToProps = function mapStateToProps(state) {
  var urlParams = buildOrderQueryParams(state);
  var url = getTariffUrl(state);
  return {
    children: getTariffButtonText(state),
    href: "".concat(url, "?").concat(urlParams)
  };
};
export var TariffButton = connect(mapStateToProps)(_TariffButton);